function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import { withTheme } from "@material-ui/core/styles";
import { withTrackerContext } from "@dpdgroupuk/react-event-tracker";
import { IMAGES } from "../../themes/constants";
import { getImageSrc } from "../../themes";
export const PageContext = /*#__PURE__*/React.createContext({});

const trackControlActions = (controlActions = [], tracker) => controlActions.map(([title, control, actionId]) => {
  const isAction = typeof control === "function";
  return [title, { ...(!isAction && control),
    callback: () => {
      tracker.logEvent(actionId);
      isAction && control();
    }
  }];
});

class PageContextProvider extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "setHeaderMenuActions", actions => {
      this.setState({
        headerMenuActions: trackControlActions(actions, this.props.tracker)
      });
    });

    _defineProperty(this, "setSpeedDialActions", actions => {
      this.setState({
        speedDialActions: trackControlActions(actions, this.props.tracker)
      });
    });

    _defineProperty(this, "setTitle", title => {
      this.setState({
        title
      });
    });

    _defineProperty(this, "setBackgroundImage", backgroundImage => {
      this.setState({
        backgroundImage
      });
    });

    _defineProperty(this, "setBackgroundOpacity", backgroundOpacity => {
      this.setState({
        backgroundOpacity
      });
    });

    _defineProperty(this, "setSpeedDealMenuOpened", isSpeedDealMenuOpened => {
      this.setState({
        isSpeedDealMenuOpened: !!isSpeedDealMenuOpened
      });
    });

    _defineProperty(this, "setSpeedDialIconWithAction", speedDialIconWithAction => {
      this.setState({
        speedDialIconWithAction
      });
    });

    _defineProperty(this, "setFooterHidden", isFooterHidden => {
      this.setState({
        isFooterHidden: !!isFooterHidden
      });
    });

    _defineProperty(this, "setShevronVisible", isMobileMenuShevronVisible => {
      this.setState({
        isMobileMenuShevronVisible: !!isMobileMenuShevronVisible
      });
    });

    this.state = {
      title: props.title || "",
      backgroundOpacity: props.backgroundOpacity || false,
      isSpeedDealMenuOpened: props.isSpeedDealMenuOpened || true,
      speedDialIconWithAction: props.speedDialIconWithAction || [],
      backgroundImage: props.backgroundImage || IMAGES.TRACKING_BG,
      speedDialActions: trackControlActions(props.speedDialActions, props.tracker) || [],
      headerMenuActions: trackControlActions(props.headerMenuActions, props.tracker) || [],
      isFooterHidden: props.isFooterHidden || false,
      isMobileMenuShevronVisible: props.isMobileMenuShevronVisible || false
    };
  }

  render() {
    const {
      backgroundImage
    } = this.state;
    return /*#__PURE__*/React.createElement(PageContext.Provider, {
      value: { ...this.state,
        backgroundImage: getImageSrc(backgroundImage, this.props.theme.name) || backgroundImage,
        setTitle: this.setTitle,
        setBackgroundImage: this.setBackgroundImage,
        setBackgroundOpacity: this.setBackgroundOpacity,
        setHeaderMenuActions: this.setHeaderMenuActions,
        setSpeedDialActions: this.setSpeedDialActions,
        setSpeedDealMenuOpened: this.setSpeedDealMenuOpened,
        setSpeedDialIconWithAction: this.setSpeedDialIconWithAction,
        setFooterHidden: this.setFooterHidden,
        setShevronVisible: this.setShevronVisible
      }
    }, this.props.children);
  }

}

export default withTrackerContext(withTheme(PageContextProvider));